import type { AttendanceWithUser } from "@/features/sessions/types";

/**
 * Get the count of checked-in attendees
 * Checked-in means attendedAt is set
 * @param records - Array of attendance records
 * @returns Number of checked-in attendees
 */
export function getCheckedInCount(records: AttendanceWithUser[]): number {
    return records.filter((record) => record.attendedAt != null).length;
}

/**
 * Get the count of unresolved attendance records
 * Unresolved means resolvedAt is not set
 * @param records - Array of attendance records
 * @returns Number of unresolved records
 */
export function getUnresolvedCount(records: AttendanceWithUser[]): number {
    return records.filter((record) => record.resolvedAt == null).length;
}

/**
 * Get table counts grouped by table number
 * Counts non-cancelled records with an assigned table (tableNumber), including before check-in
 * @param records - Array of attendance records
 * @param maxTableCount - Maximum number of tables
 * @returns Map of table number to count
 */
export function getTableCounts(records: AttendanceWithUser[], maxTableCount: number): Map<number, { count: number }> {
    const counts = new Map<number, { count: number }>();

    // Initialize all tables with 0 count
    for (let i = 1; i <= maxTableCount; i++) {
        counts.set(i, { count: 0 });
    }

    records.forEach((record) => {
        if (record.cancelledAt != null) {
            return;
        }
        if (record.tableNumber != null) {
            const tableNum = record.tableNumber;
            const current = counts.get(tableNum);
            if (current) {
                counts.set(tableNum, { count: current.count + 1 });
            }
        }
    });

    return counts;
}
